// Construit l'URL de l'écran d'intro d'une partie (langue, vidéo tuto, type d'intro).
// Utilisé au lancement d'un atelier et à sa reprise depuis le profil.
export const buildIntroPath = (gameId, { gameConfigId, language, tutoUrl, customIntro, bassin }) => {
  const params = new URLSearchParams();

  if (language) {
    params.append("language", language);
  }

  if (tutoUrl) {
    params.append("tuto_url", tutoUrl);
  }

  let basePath;
  if (customIntro) {
    basePath = `/custom_intro/${gameId}`;
    params.append("game_config", gameConfigId);
  } else {
    basePath = `/intro/${gameId}`;
    params.append("bassin", bassin || "rhone");
  }

  return `${basePath}?${params.toString()}`;
};

// Relit les réglages d'intro depuis la config de la partie
export const fetchIntroSettings = async (gameId) => {
  const response = await fetch(`${process.env.REACT_APP_API_URL}/game/${gameId}/intro_settings`);
  if (!response.ok) {
    throw new Error("Network response was not ok");
  }
  return response.json();
};
